import styled from "@emotion/styled";
import Button from "@mui/material/Button";

const CustomButtonDelete = styled(Button)({
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    padding: '6px 12px',
    border: '1px solid',
    borderRadius: '4px',
    lineHeight: 1.5,
    color: '#F83E5A',
    backgroundColor: 'white',
    borderColor: '#F83E5A',
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
        backgroundColor: '#FFD9DF',
        borderColor: '#F83E5A',
        color: '#333333',
        boxShadow: 'none',

    },
    '&:active': {
        boxShadow: 'none',
        backgroundColor: 'white',
        borderColor: '#F83E5A',
    },
    '&:focus': {
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
});

export default CustomButtonDelete;
